import { useCallback, useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ContractModalBody } from "./contractmodalbody";
import { initialState, reducer } from "./contractreducer";
import { getContract } from "../../../actions/contracts/contractget";
import { detailContractSelector } from "../../../reducers";
import LoadingCentered from "../../../common/loaders/loadingcentered";

export default function EditContractModal({ contract, onCancel, onSave, onLock, onUnlock, checkPersonNumber, personNumberCheckResult, actionType, onFormErrors, setPdf }) {
  const reduxDispatch = useDispatch();
  const clearContractDetails = useCallback( () => reduxDispatch({type: "CLEAR_CONTRACT_DETAILS"}) );

  const detailContract = useSelector(detailContractSelector);

  const path = window.location.pathname;
  const isPersonal = path.startsWith("/personal");

  const { t } = useTranslation();

  const [ state, dispatch ] = useReducer(reducer, initialState);

  useEffect(() => {
    if (contract != null && contract.contractId) {
      reduxDispatch(getContract(contract.contractId));
    }

    return clearContractDetails; // cleanup
  }, [contract]);

  useEffect(() => {
    if (contract != null && detailContract != null) {
      dispatch({type: "open_for_editing", payload: detailContract});
    }
  }, [detailContract]);

  function handleSave() {
    onSave(state);
  }

  const [ lock, setLock ] = useState(false);

  function handleLock() {
    if (state.status === "DRAFT" || state.status === "REOPENED") {
      setLock(true); // save first and then lock in useEffect
      handleSave();
    } else if (state.status === "COMPLETE") {
      onUnlock(state.contractId);
    }
  }

  useEffect(() => {
    if (lock && actionType === "POST_CONTRACT_EDIT_SUCCEEDED") {
      onLock(state.contractId);
    }
  }, [actionType]);

  let title = "modalTitle";
  if (!state.modelName && !state.newModel) {
    title=(state.status === "COMPLETE" ? t("ViewContract", "Työsopimuksen tarkastelu") : t("EditContract", "Työsopimuksen päivitys")) + ` - ${contract?.person?.name} - ${contract?.identifier}`;
  } else if (state.modelName || state.newModel) {
    title=t("ModelUpdate", "Mallin päivitys") + ` ${contract?.identifier}`;
  }


  return state.contractId
    ? <ContractModalBody
      show
      state={state}
      dispatch={dispatch}
      title={title}
      handleSave={handleSave}
      handleCancel={onCancel}
      handleLock={!isPersonal ? handleLock : undefined}
      checkPersonNumber={checkPersonNumber}
      personNumberCheckResult={personNumberCheckResult}
      actionType={actionType}
      onFormErrors={onFormErrors}
      setPdf={setPdf}
    />
    : <LoadingCentered show />;
}
